import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { HttpService } from './http.service';

import {  ApiConfig, RequestParam } from 'src/app/shared/models/app';
import { Environment } from '../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class BaseService extends HttpService {
  /*********************Properties*********************/
  protected get apiConfig(): ApiConfig {
    return Environment.getInstance().apiConfig;
  }
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(protected http: HttpClient) {
    super(http);
    
  }
  /*********************Constructor*********************/

  /*********************Service Methods*********************/

  protected serviceUrl(...suffix : any[]) {
    return Array.prototype.concat(suffix).join('');
  }

  protected getRequestParams(params: RequestParam[]): string {
    let queryString = '';

    params.forEach((param) => {
      queryString += queryString ? '&' : '?';
      queryString += param.key + '=' + param.value;
    });

    return queryString;
  }

  /*********************Service Methods*********************/
}
